import { TextSkeleton } from '@/ui/skeleton/TextSkeleton'

type SkeletonSet = {
  nbOfLine: number
  title?: boolean
}

type ProductAvailabilitiesSkeletonProps = {
  offset: SkeletonSet[]
}

export function ProductAvailabilitiesSkeleton({ offset }: ProductAvailabilitiesSkeletonProps) {
  return (
    <div className="flex flex-col gap-2">
      {offset.map((set, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <div key={index} className="flex flex-col gap-0.5">
          {set.title && <TextSkeleton className="w-18" size="lg" leading="normal" />}
          {Array.from({ length: set.nbOfLine }, (_, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <TextSkeleton key={index} className="w-18" size="md" leading="normal" />
          ))}
        </div>
      ))}
    </div>
  )
}
